<template>
  <div class="coach-register">
    <header class="inner-banner">
      <div class="container">
        <div class="row">
          <div class="inner-wrapper">
            <div class="col-md-12">
              <!-- Login -->
              <div class="container">
                <div class="card card-container">
                  <CoachRegister v-if="register === 'coach'" />
                  <CollegeRegister v-else />
                  <div class="signin-help">
                    <div class="next-option">
                      <div
                        class="change-form"
                        v-if="register === 'coach'"
                        @click="ChangeRegister('college')"
                      >
                        College Not Available in Dropdown? Click Here
                      </div>
                      <div
                        class="change-form"
                        v-else
                        @click="ChangeRegister('coach')"
                      >
                        Verify Your Coach Account
                      </div>
                    </div>
                    <div class="divider">
                      <p>or</p>
                    </div>
                    <div class="login-link">
                      Already have an account?
                      <a href="/login">Login</a>
                    </div>
                    <div class="divider">
                      <p>or</p>
                    </div>
                    <a class="back-to-home" href="/">
                      Back To Top Notch Athletes</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import CoachRegister from "./coach-register";
import CollegeRegister from "./college-register";

export default {
  name: "RegisterForm",
  components: {
    CoachRegister,
    CollegeRegister
  },
  data() {
    return {
      register: "coach"
    };
  },
  methods: {
    ChangeRegister(val) {
      this.register = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.card-container {
  max-width: 500px !important;
  &.card {
    padding: 40px 40px 0;
  }
}
.signin-help {
  display: block;
  position: relative;
  z-index: 1;
  display: flex;
  margin: 0;
  padding: 20px 0 40px;
  justify-content: space-between;
  flex-wrap: wrap;
  .login-link {
    text-align: center;
    font-size: 14px;
    color: #8b8b8b;
    width: 100%;
    a {
      cursor: pointer;
      font-weight: 500;
      padding-left: 10px;
      text-transform: uppercase;
      text-decoration: underline;
    }
  }
  .divider {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    padding: 15px 0;
    &::before {
      content: "";
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      width: 60%;
      height: 1px;
      background: #8b8b8b;
    }
    p {
      font-size: 12px;
      color: #8b8b8b;
      text-align: center;
      width: fit-content;
      margin: 0 auto 0 !important;
      padding: 0 10px;
      background: #ffffff;
      position: relative;
      z-index: 1;
    }
  }
  .next-option {
    width: 100%;
    .change-form {
      cursor: pointer;
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      color: #8b8b8b;
    }
  }
  .back-to-home {
    width: 100%;
    cursor: pointer;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: blue;
    text-decoration: underline;
  }
}
</style>
